import React, { useEffect, useState } from "react";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import {
  AddUserPostApi,
  EditUserAPI,
  getColorListAPI,
  getDeliveryInfoApi,
  getVehicleListApi,
} from "../../../../Api/PanelAdminServices";
import Style from "./EditDeliveryContainer.module.scss";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import { useParams } from "react-router-dom";

const EditDeliveryContainer = () => {
  const [photo, setPhoto] = useState("");
  const [chooseCity, setChooseCity] = useState();
  const [disable, setDisable] = useState(false);
  const [userInfoState, setUserInfoState] = useState([]);
  const [chooseColor, setChooseColor] = useState();
  const [chooseVehical, setChooseVehical] = useState();
  const [ColorListState, setColorListState] = useState([]);
  const [VehicleListState, setVehicleListState] = useState([]);
  const params = useParams();

  useEffect(() => {
    getDeliveryInfoHandler();
  }, []);
  const path = window.location.pathname.split("/");
  const getDeliveryInfoHandler = () => {
    getDeliveryInfoApi(path[2], (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setUserInfoState(res.info);
        } else {
          console.log(res.message);
        }
      } else {
        console.log(res);
      }
    });
  };

  const city = [
    {
      value: "1",
      label: "بهشهر",
      cityId: "4851",
    },
    {
      value: "2",
      label: "گلوگاه",
      cityId: "4861",
    },
    {
      value: "3",
      label: "نکا",
      cityId: "4841",
    },
  ];

  //////آپلود کردن عکس
  const UploadPhoto = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onsubmit = (data) => {
    setDisable(true);
    let info = {
      id: path[2],
      first_name: data.name,
      last_name: data.lName,
      phone: data.phone,
      national_code: data.nationalcode,
      email: data.email ? data.email : "",
      city_id:
        chooseCity !== undefined ? chooseCity.cityId : defaultCity.cityId,
      user_type: "deliver",
      photo: photo,
    };
    EditUserAPI(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
        setDisable(false);
      } else {
        errorToast(res.message);
        setDisable(false);
      }
    });
  };
  useEffect(() => {
    getDataHandler();
  }, []);
  const getDataHandler = () => {
    getDeliveryInfoApi(params.id, (succ, res) => {
      if (res.status === 1) {
        setUserInfoState(res.info);
      } else {
        errorToast(res.message);
      }
    });
    getColorListAPI((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setColorListState(res.colors);
        } else {
          errorToast(res.message);
        }
      } else {
        console.log(res);
      }
    });
    getVehicleListApi((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setVehicleListState(res.models);
        } else {
          errorToast(res.message);
        }
      } else {
        console.log(res);
      }
    });
  };
  let colorList = [];
  ColorListState.forEach((element) => {
    colorList.push({
      value: element.id,
      label: element.color,
    });
  });
  let vehicleListArray = [];
  VehicleListState.forEach((element) => {
    vehicleListArray.push({
      value: element.id,
      label: element.model,
    });
  });

  const defaultCity = city.filter(
    (e) => e.cityId === userInfoState?.city_id
  )[0];
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ویرایش پیک "} />
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          <section className={Style.logoPart}>
            <div className={Style.titleLogo}>بارگذاری تصویر</div>
            <div className={Style.uploadImage}>
              <img
                src={
                  photo === ""
                    ? `https://cdn.barest.ir/deliver/photo/${userInfoState.photo}.jpg`
                    : photo
                }
                alt=""
              />
            </div>
            <input
              id={"uploadPhoto"}
              type="file"
              style={{ display: "none" }}
              onChange={(e) => UploadPhoto(e.target.files[0])}
            />
            <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
              <FontAwesomeIcon className={Style.icon} icon={faImage} />
            </label>
            <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
          </section>

          <input
            className={errors.name ? Style.errorInput : Style.inputPart}
            placeholder={"نام"}
            defaultValue={userInfoState.first_name}
            {...register("name", { required: true })}
          />

          <input
            className={errors.lName ? Style.errorInput : Style.inputPart}
            placeholder={"نام خانوادگی "}
            defaultValue={userInfoState.last_name}
            {...register("lName", { required: true })}
          />

          {defaultCity ? (
            <Select
              defaultValue={{
                label: defaultCity.label,
                value: defaultCity.value,
              }}
              onChange={setChooseCity}
              options={city}
              placeholder={" شهر"}
              className={Style.selectPart}
            />
          ) : null}
          <input
            className={errors.phone ? Style.errorInput : Style.inputPart}
            placeholder={"شماره همراه"}
            defaultValue={userInfoState.phone}
            {...register("phone", { required: true })}
          />
          <input
            className={Style.inputPart}
            placeholder={"ایمیل "}
            defaultValue={userInfoState.email}
            {...register("email")}
          />
          <input
            className={errors.nationalcode ? Style.errorInput : Style.inputPart}
            placeholder={"کدملی "}
            defaultValue={userInfoState.national_code}
            {...register("nationalcode", { required: true })}
          />
          <Select
              onChange={setChooseVehical}
              options={vehicleListArray}
              placeholder={" مدل وسیله نقلیه"}
              className={Style.selectPart}
              defaultValue={vehicleListArray.filter(
                (option) => option.value === userInfoState.vehicle_model
              )}
            />
            <Select
              onChange={setChooseColor}
              options={colorList}
              placeholder={" رنگ وسیله نقلبه"}
              className={Style.selectPart}
              defaultValue={colorList.filter(
                (option) => option.value === userInfoState.vehicle_color
              )}
            />
          <input
            className={
              errors.vehicle_plate ? Style.errorInput : Style.inputPart
            }
            placeholder={"پلاک ماشین "}
            {...register("vehicle_plate", { required: true })}
            defaultValue={userInfoState.vehicle_plate}
          />

          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ویرایش کردن
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditDeliveryContainer;
